var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";

var PaintIcon = function PaintIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "shale" : _ref$color,
      onClick = _ref.onClick,
      cursor = _ref.cursor,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      props = _objectWithoutProperties(_ref, _excluded);

  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.313 10.133l4.834-3.065c1.137-1.145 1.137-3.065 0-4.21-1.137-1.144-3.046-1.144-4.224 0l-3.006 4.823s-.65.858-1.178.735l-.731-.735c-.853-.859-1.666-.532-2.031-.245l-.488.49a.427.427 0 000 .654l5.85 5.885a.492.492 0 00.65 0l.527-.531c.285-.327.61-1.145-.243-2.003l-.69-.695c-.106-.352.422-.825.649-1.028l.081-.075zm-7.677-.777a.491.491 0 00-.65-.04l-.568.49c-3.656 3.106-5.037 3.392-5.037 3.392-.163.04-.325.163-.366.327a.54.54 0 00.122.49l.853.859a.437.437 0 00.528.081l1.422-.776-.934 1.144c-.163.204-.122.45.04.613l.69.695a.496.496 0 00.529.082l1.137-.573-.569 1.145a.504.504 0 00.082.531l.365.368c.163.163.406.163.61.04l1.259-.898-.813 1.39c-.121.203-.08.408.082.571l.325.327c.162.164.446.205.609.041l1.625-1.349-1.016 2.126a.504.504 0 00.081.531l.894.9a.457.457 0 00.447.122c.162-.041.284-.205.325-.368 0 0 .203-.9 1.828-3.106l2.071-2.452c.163-.205.163-.45-.04-.654l-5.93-6.049z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 2,
        y: 2,
        width: 20,
        height: 20,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.313 10.133l4.834-3.065c1.137-1.145 1.137-3.065 0-4.21-1.137-1.144-3.046-1.144-4.224 0l-3.006 4.823s-.65.858-1.178.735l-.731-.735c-.853-.859-1.666-.532-2.031-.245l-.488.49a.427.427 0 000 .654l5.85 5.885a.492.492 0 00.65 0l.527-.531c.285-.327.61-1.145-.243-2.003l-.69-.695c-.106-.352.422-.825.649-1.028l.081-.075zm-7.677-.777a.491.491 0 00-.65-.04l-.568.49c-3.656 3.106-5.037 3.392-5.037 3.392-.163.04-.325.163-.366.327a.54.54 0 00.122.49l.853.859a.437.437 0 00.528.081l1.422-.776-.934 1.144c-.163.204-.122.45.04.613l.69.695a.496.496 0 00.529.082l1.137-.573-.569 1.145a.504.504 0 00.082.531l.365.368c.163.163.406.163.61.04l1.259-.898-.813 1.39c-.121.203-.08.408.082.571l.325.327c.162.164.446.205.609.041l1.625-1.349-1.016 2.126a.504.504 0 00.081.531l.894.9a.457.457 0 00.447.122c.162-.041.284-.205.325-.368 0 0 .203-.9 1.828-3.106l2.071-2.452c.163-.205.163-.45-.04-.654l-5.93-6.049z"
        })
      })]
    }))
  });
};

var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
PaintIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  PaintIcon = nessiePropCheckerWrapper(PaintIcon);
}

export default PaintIcon;
//# sourceMappingURL=PaintIcon.js.map